<div class="titles">
  <div class="eyebrow" *ngIf="product.title.includes(' | ')">
    {{
      product.title.includes(" | ")
        ? product.title.split(" | ")[0]
        : product.title
    }}
  </div>
  <div class="d-flex flex-column flex-lg-row align-items-start">
    <h1 class="lh-1 h2 me-3">
      {{ product.title | titleExtractor }}
    </h1>
    <app-price
      class="ms-0 ms-lg-auto mt-1 mt-lg-0"
      [product]="product"
    ></app-price>
  </div>
</div>
